import { useTheme } from "styled-components";
import React, { CSSProperties } from "react";
import { GetMarginStyle, GetPaddingStyle } from "core/styles/paddingMarginStyle";
import { Container } from "./_dividerStyle";

type Props = {
  variant?: "horizontal" | "vertical";
  width?: string;
  height?: string;
  size?: string | number;
  color?: string;
  dashed?: boolean;
  density?: "high" | "low";
  style?: CSSProperties;
} & GetMarginStyle &
  GetPaddingStyle;

function Divider(props: Props) {
  const theme = useTheme();

  const { color = theme?.colors?.neutral.neutral90, ...rest } = props;

  return <Container color={color} {...rest} />;
}

Divider.defaultProps = {
  size: 1,
  width: "auto",
  dashed: false,
  density: "low",
};

export default Divider;
